import { useMemo } from 'react';

const { useEffect, useState } = require('react');

const useGetWalletDetails = () => {

    const [dspAccountDetail, setDspAccountDetail] = useState({})

    const selectedProfile = useMemo(() => JSON.parse(sessionStorage.getItem('selectedProfileId')), [localStorage]);
    const masterAccountFilter = useMemo(() => JSON.parse(sessionStorage.getItem('master-account-filters')), [localStorage]);

    const computedRechargeAccount = useMemo(() => {
        if (!dspAccountDetail || Object.keys(dspAccountDetail).length === 0) {
            return null;
        }

        if ((dspAccountDetail?.seat?.toLowerCase() === 'mixshift' || dspAccountDetail?.seat?.toLowerCase() === 'neon_old') && Array.isArray(selectedProfile.dsp) && selectedProfile.dsp.length > 0) {
            const rechargeDspAccount = selectedProfile.dsp.find((item) => item?.seat?.toLowerCase() === 'neon');
            return rechargeDspAccount || dspAccountDetail;
        }
        
        return dspAccountDetail;
    }, [dspAccountDetail, selectedProfile]);

    useEffect(() => {
        if (selectedProfile && selectedProfile?.dsp && selectedProfile?.dsp?.length > 0) {
            if (
                masterAccountFilter &&
                selectedProfile?.profileId &&
                masterAccountFilter[selectedProfile?.profileId] &&
                masterAccountFilter[selectedProfile?.profileId]?.length > 0
            ) {
                const selectedDspId = masterAccountFilter[selectedProfile?.profileId]?.find((item) => item?.level === 'dsp')?.keywords;
                const selectedDspAccount = selectedProfile?.dsp?.find((item) => (Array.isArray(selectedDspId) && selectedDspId?.length > 0) ? (item?.dspId === selectedDspId[0]) : (item?.dspId === String(selectedDspId)));
                if(selectedDspAccount) {
                    setDspAccountDetail(selectedDspAccount);
                } else {
                    setDspAccountDetail(selectedProfile?.dsp?.[0]);    
                }
            } else {
                setDspAccountDetail(selectedProfile?.dsp?.[0]);
            }
        }
        return () => {
            setDspAccountDetail({})
        }
    }, [selectedProfile, masterAccountFilter]);

    return {
        dspAccount: dspAccountDetail,
        rechargeDspAccount: computedRechargeAccount || {}
    }
}

export default useGetWalletDetails;